<template>
  <div v-editable="blok" feature-tab :style="[backgroundGradient(blok)]">
    <div v-if="blok?.description" class="group-description">
      <StoryblokRichText :doc="blok.description" />
    </div>
    <div class="group-details">
      <div class="group-features" :data-odd="blok.features.length % 2">
        <div v-for="(feature, f) in blok.features" :key="f" v-editable="feature" class="feature">
          <div v-if="feature?.icon?.filename" class="feature-icon">
            <img v-if="feature.icon?.filename" loading="lazy" :src="optimizeImage(feature.icon.filename)" :alt="`Feature Icon ${feature.icon.alt}`" />
          </div>
          <div class="feature-title">
            <StoryblokRichText :doc="feature.title" />
          </div>
          <div class="feature-description">
            <StoryblokRichText :doc="feature.description" />
          </div>
        </div>
      </div>
      <div v-if="blok?.buttons && blok?.buttons?.length > 0" class="group-buttons">
        <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
      </div>
    </div>
    <div v-if="blok?.image?.filename" class="group-image" :data-align="blok.image_position || 'bottom'">
      <img :src="optimizeImage(blok.image.filename)" :alt="`Feature Group Image ${blok._uid}`" loading="lazy" />
    </div>
  </div>
</template>
<script setup>
  defineProps({ blok: Object });

  const backgroundGradient = (tab) => {
    if (!tab.background_gradient) return null;
    return {
      background: tab.background_gradient,
    };
  };
</script>
